import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GridModule } from '@progress/kendo-angular-grid';
import { ContextMenuModule as KendoAngularContextMenuModule } from "@progress/kendo-angular-menu";
import { AngularSplitModule } from 'angular-split';
import { NgxEchartsModule } from 'ngx-echarts';
import { MessageService, TreeDragDropService } from 'primeng/api';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToastModule } from 'primeng/toast';
import { TreeModule } from 'primeng/tree';
import { CUSTOM_DATE_FORMATS, CustomDatePickerAdapter } from '../shared/adapters/date-adapter';
import { AutocompleteComponent } from '../shared/components/autocomplete/autocomplete.component';
import { BreadcrumbsComponent } from '../shared/components/breadcrumbs/breadcrumbs.component';
import { ContextMenuComponent } from '../shared/components/context-menu/context-menu.component';
import { DecoratorButtonComponent } from '../shared/components/decorator-button/decorator-button.component';
import { EntityNameEditorComponent } from '../shared/components/entity-name-editor/entity-name-editor.component';
import { FileUploaderComponent } from '../shared/components/file-uploader/file-uploader.component';
import { FolderDetailsComponent } from '../shared/components/folder-details/folder-details.component';
import { FolderTreeComponent } from '../shared/components/folder-tree/folder-tree.component';
import { FlexibleSelectionFieldConfigurationComponent } from '../shared/components/form-builder/field-configuration/flexible-selection-field-configuration/flexible-selection-field-configuration.component';
import { FormBuilderComponent } from '../shared/components/form-builder/form-builder.component';
import { FormConditionalPropertiesComponent } from '../shared/components/form-builder/properties/form-conditional-properties/form-conditional-properties.component';
import { FormFieldPropertiesComponent } from '../shared/components/form-builder/properties/form-field-properties/form-field-properties.component';
import { FormPropertiesComponent } from '../shared/components/form-builder/properties/form-properties/form-properties.component';
import { LayoutRowPropertiesComponent } from '../shared/components/form-builder/properties/layout-row-properties/layout-row-properties.component';
import { FormDetailsComponent } from '../shared/components/form-details/form-details.component';
import { FormFieldConstraintsComponent } from '../shared/components/form-field-constraints/form-field-constraints.component';
import { AttachmentFormFieldComponent } from '../shared/components/form-fields/attachment-form-field/attachment-form-field.component';
import { CascadingDropDownFormFieldComponent } from '../shared/components/form-fields/cascading-drop-down-form-field/cascading-drop-down-form-field.component';
import { CheckboxFormFieldComponent } from '../shared/components/form-fields/checkbox-form-field/checkbox-form-field.component';
import { CommentsFormFieldComponent } from '../shared/components/form-fields/comments-form-field/comments-form-field.component';
import { ContactsFormFieldComponent } from '../shared/components/form-fields/contacts-form-field/contacts-form-field.component';
import { CurrencyFormFieldComponent } from '../shared/components/form-fields/currency-form-field/currency-form-field.component';
import { DateFormFieldComponent } from '../shared/components/form-fields/date-form-field/date-form-field.component';
import { DecimalFormFieldComponent } from '../shared/components/form-fields/decimal-form-field/decimal-form-field.component';
import { DevOnlyFormFieldComponent } from '../shared/components/form-fields/dev-only-form-field/dev-only-form-field.component';
import { DropDownFormFieldComponent } from '../shared/components/form-fields/drop-down-form-field/drop-down-form-field.component';
import { FlexibleSelectionFormFieldComponent } from '../shared/components/form-fields/flexible-selection-form-field/flexible-selection-form-field.component';
import { FootnoteFormFieldComponent } from '../shared/components/form-fields/footnote-form-field/footnote-form-field.component';
import { FormFieldWrapperComponent } from '../shared/components/form-fields/form-field-wrapper/form-field-wrapper.component';
import { FormTemplateInstancesComponent } from '../shared/components/form-fields/form-template-instances/form-template-instances.component';
import { FormulaFormFieldComponent } from '../shared/components/form-fields/formula-form-field/formula-form-field.component';
import { GridCascadingDropDownFormFieldComponent } from '../shared/components/form-fields/grid-cascading-dropdown/grid-cascading-dropdown.component';
import { GridFieldDesignerComponent } from '../shared/components/form-fields/grid-field-designer/grid-field-designer.component';
import { GridFieldEditorComponent } from '../shared/components/form-fields/grid-field-editor/grid-field-editor.component';
import { GridFormFieldComponent } from '../shared/components/form-fields/grid-form-field/grid-form-field.component';
import { HtmlLinkFieldComponent } from '../shared/components/form-fields/html-link-field/html-link-field.component';
import { InlineContentFormFieldComponent } from '../shared/components/form-fields/inline-content-form-field/inline-content-form-field.component';
import { InstructionsFormFieldComponent } from '../shared/components/form-fields/instructions-form-field/instructions-form-field.component';
import { IntegerFormFieldComponent } from '../shared/components/form-fields/integer-form-field/integer-form-field.component';
import { FlexFieldButtonsFormFieldComponent } from '../shared/components/form-fields/flex-field-buttons-form-field/flex-field-buttons-form-field.component';
import { LabelFormFieldComponent } from '../shared/components/form-fields/label-form-field/label-form-field.component';
import { MarkDataReadOnlyComponent } from '../shared/components/form-fields/mark-data-readonly/mark-data-readonly.component';
import { MultiCheckboxFormFieldComponent } from '../shared/components/form-fields/multi-checkbox-form-field/multi-checkbox-form-field.component';
import { MultiDropDownFormFieldComponent } from '../shared/components/form-fields/multi-drop-down-form-field/multi-drop-down-form-field.component';
import { ParagraphFormFieldComponent } from '../shared/components/form-fields/paragraph-form-field/paragraph-form-field.component';
import { RadioButtonsFormFieldComponent } from '../shared/components/form-fields/radio-buttons-form-field/radio-buttons-form-field.component';
import { RawHtmlFormFieldComponent } from '../shared/components/form-fields/raw-html-form-field/raw-html-form-field.component';
import { RichTextFormFieldComponent } from '../shared/components/form-fields/rich-text-form-field/rich-text-form-field.component';
import { ShortTextFormFieldComponent } from '../shared/components/form-fields/short-text-form-field/short-text-form-field.component';
import { ShowToHideFromComponent } from '../shared/components/form-fields/show-to-hide-from/show-to-hide-from.component';
import { TelerikHtmlEditorComponent } from '../shared/components/form-fields/telerik-html-editor/telerik-html-editor.component';
import { ValueConcatenatorFormFieldComponent } from '../shared/components/form-fields/value-concatenator-form-field/value-concatenator-form-field.component';
import { FormFillerComponent } from '../shared/components/form-filler/form-filler.component';
import { FormInstanceDetailsComponent } from '../shared/components/form-instance-details/form-instance-details.component';
import { FormInstanceHistoryComponent } from '../shared/components/form-instance-history/form-instance-history.component';
import { FormRendererComponent } from '../shared/components/form-renderer/form-renderer.component';
import { GenerateEtlJobComponent } from '../shared/components/generate-etl-job/generate-etl-job.component';
import { MagicStructureMembershipComponent } from '../shared/components/magic-struct-membership/magic-struct-membership.component';
import { MaxPickerComponent } from '../shared/components/max-picker/max-picker.component';
import { RoleViewerComponent } from '../shared/components/role-viewer/role-viewer.component';
import { SiteBetaFeaturesComponent } from '../shared/components/site-beta-features/site-beta-features.component';
import { SiteContactsComponent } from '../shared/components/site-contacts/site-contacts.component';
import { SiteRolesComponent } from '../shared/components/site-roles/site-roles.component';
import { SiteWorkflowStatusComponent } from '../shared/components/site-workflow-status/site-workflow-status.component';
import { ToggleSitePermissionModelComponent } from '../shared/components/toggle-site-permission-model/toggle-site-permission-model.component';
import { WorkflowDetailsComponent } from '../shared/components/workflow-details/workflow-details.component';
import { AssignNameDialog } from '../shared/dialogs/assign-name/assign-name.dialog';
import { ConfigureHomePageGridColumnsDialog } from '../shared/dialogs/configure-home-page-grid-columns/configure-home-page-grid-columns.dialog';
import { CreateNotificationDialog } from '../shared/dialogs/create-notification/create-notification.dialog';
import { DisplayContentDialog } from '../shared/dialogs/display-content/display-content.dialog';
import { DocumentPublishingPickerDialog } from '../shared/dialogs/document-publishing/document-publishing-picker.dialog';
import { DocumentPublishingSettingsEditorDialog } from '../shared/dialogs/document-publishing/document-publishing-settings-editor.dialog';
import { AddContactDialog } from '../shared/dialogs/add-contact/add-contact.dialog';
import { ExportCsvDialog } from '../shared/dialogs/export-csv/export-csv.dialog';
import { ExportDataDialog } from '../shared/dialogs/export-data/export-data.dialog';
import { ExportFormDataDialog } from '../shared/dialogs/export-form-data/export-form-data.dialog';
import { ExportStructureInstancesDialog } from '../shared/dialogs/export-structure/export-structure.dialog';
import { GeocodeDialog } from '../shared/dialogs/geocode/geocode-dialog.component';
import { GetSiteEtlMetadataDialog } from '../shared/dialogs/get-site-etl-metadata/get-site-etl-metadata.dialog';
import { GridCellEditorDialog } from '../shared/dialogs/grid-cell-editor/grid-cell-editor.dialog';
import { HomePageActionDialog } from '../shared/dialogs/home-page-action/home-page-action.dialog';
import { HtmlEditorDialog } from '../shared/dialogs/html-editor/html-editor.dialog';
import { ImportDataFromExcelDialog } from '../shared/dialogs/import-data/import-data-from-excel.dialog';
import { ImportDragDropComponent } from '../shared/dialogs/import-drag-drop/import-drag-drop.component';
import { ImportFormInstancesDialog } from '../shared/dialogs/import-form-data/import-form-instances.dialog';
import { ImportFormDefinitionDialog } from '../shared/dialogs/import-form-definition/import-form-definition.dialog';
import { ImportGridDataDialog } from '../shared/dialogs/import-grid-data/import-grid-data.dialog';
import { ImportStructureInstancesDialog } from '../shared/dialogs/import-structure/import-structure.dialog';
import { ListIconsDialog } from '../shared/dialogs/list-icons/list-icons.dialog';
import { MagicStructureSetupDialog } from '../shared/dialogs/magic-structure-setup/magic-structure-setup.dialog';
import { ReorderGridColumnsDialog } from '../shared/dialogs/reorder-grid-columns/reorder-grid-columns.dialog';
import { RoleMembershipDrawerComponent } from '../shared/dialogs/role-membership-drawer/role-membership-drawer.component';
import { ScheduledEventsDialog } from '../shared/dialogs/scheduled-events-dialog/scheduled-events.dialog';
import { SelectFolderDialog } from '../shared/dialogs/select-folder/select-folder.dialog';
import { SiteMilestoneDialog } from '../shared/dialogs/site-milestone/site-milestone.dialog';
import { UploadIconDialog } from '../shared/dialogs/upload-icon/upload-icon.dialog';
import { CustomDateFormatDirective } from '../shared/directives/custom-date-format.directive';
import { DecimalFormatDirective } from '../shared/directives/decimal-format-directive';
import { DynamicComponentHostDirective } from '../shared/directives/dynamic-content-host.directive';
import { FluidHeightDirective } from '../shared/directives/fluid-height.directive';
import { FormInstanceHistoryRemoteDirective } from '../shared/directives/form-instance-history-remote.directive';
import { FormTemplateInstancesGridRemoteBindingDirective } from '../shared/directives/form-template-instances-remote.directive';
import { IntegerOnlyDirective } from '../shared/directives/integer-only.directive';
import { KendoGridRemoteBindingDirective } from '../shared/directives/kendo-grid-remote-binding.directive';
import { FilterPipe } from '../shared/filter.pipe';
import { PreserveInlineStylesPipe } from '../shared/pipes/preserve-inline-styles.pipe';
import { SafePipe } from '../shared/pipes/safe.pipe';
import { DocumentPublishingSettingsResolver } from '../shared/resolvers/document-publishing-settings.resolver';
import { FolderResolver } from '../shared/resolvers/folder.resolver';
import { FormResolver } from '../shared/resolvers/form.resolver';
import { SiteHomePageResolver } from '../shared/resolvers/site-home-page.resolver';
import { AsyncJobService } from '../shared/services/async-job.service';
import { AutocompleteService } from '../shared/services/autocomplete.service';
import { DocumentPublishingService } from '../shared/services/document-publishing.service';
import { FieldConditionalLogicService } from '../shared/services/field-conditional-logic.service';
import { ValueConcatenatorService } from '../shared/services/value-concatenator.service';
import { FlexibleSelectionFieldService } from '../shared/services/flexible-selection-field.service';
import { FolderPermissionService } from '../shared/services/folder-permission.service';
import { FormFieldDataBusService } from '../shared/services/form-field-data-bus.service';
import { CachedFormFieldService } from '../shared/services/form-field-with-cache.service';
import { FormFieldService } from '../shared/services/form-field.service';
import { InlineContentService } from '../shared/services/inline-content.service';
import { MagicStructureService } from '../shared/services/magic-structure.service';
import { MaxPickerService } from '../shared/services/max-picker.service';
import { MilestoneService } from '../shared/services/milestone.service';
import { MiscellaneousMetadataService } from '../shared/services/miscellaneous-metadata.service';
import { MostRecentFormSelectedService } from '../shared/services/most-recent-form-selected.service';
import { PermissionTestingService } from '../shared/services/permission-testing.service';
import { ScheduledEventService } from '../shared/services/scheduled-event.service';
import { SiteHomePageService } from '../shared/services/site-home-page.service';
import { TypeAheadDropdownService } from '../shared/services/type-ahead-dropdown.service';
import { VnextReleaseFeaturesService } from '../shared/services/vnext-release-features.service';
import { ConfigureBannerComponent } from '../views/site/configure-banner/configure-banner.component';
import { ConfigureHomePageComponent } from '../views/site/configure-home-page/configure-home-page.component';
import { DesignHomepageComponent } from '../views/site/design-homepage/design-homepage.component';
import { DesignComponent } from '../views/site/design/design.component';
import { DesignFormHtmlComponent } from '../views/site/design-form-html/design-form-html.component';
import { DesignHomepageHtmlComponent } from '../views/site/design-homepage-html/design-homepage-html.component';
import { FolderPermissionsComponent } from '../views/site/permissions/folder-permissions.component';
import { FilterFolderRoleMembersPipe } from '../views/site/permissions/permissions.component';
import { FilterRoleMembersPipe, PermissionRolesComponent } from '../views/site/permissions/permission-roles.component';
import { PermissionsComponent } from '../views/site/permissions/permissions.component';
import { PrintableFormComponent } from '../views/site/form/printable-form.component';
import { FormsComponent } from '../views/site/forms/forms.component';
import { FormsHtmlOnlyComponent } from '../views/site/forms-html-only/forms-html-only.component';
import { HomePageComponent } from '../views/site/home-page/home-page.component';
import { ManageComponent } from '../views/site/manage/manage.component';
import { PermissionsPreviewFiltersComponent } from '../views/site/per-pre-filters/per-pre-filters.component';
import { PermissionsPreviewWfHierarchyComponent } from '../views/site/per-pre-wf-hierarchy/per-pre-wf-hierarchy.component';
import { PermissionsPreviewComponent } from '../views/site/permissions-preview/permissions-preview.component';
import { ResponseManagementComponent } from '../views/site/response-management/response-management.component';
import { ResponseManagementConfigComponent } from '../views/site/response-mgmt-config/response-mgmt-config.component';
import { SiteMilestoneConfigComponent } from '../views/site/site-milestone-config/site-milestone-config.component';
import { SiteMilestonesComponent } from '../views/site/site-milestones/site-milestones.component';
import { StructureComponent } from '../views/site/structure/structure.component';
import { SummaryComponent } from '../views/site/summary/summary.component';
import { VirtualFolderPopoverComponent } from '../views/site/virtual-folder-popover/virtual-folder-popover.component';
import { WorkflowPermissionsComponent } from '../views/site/workflow-permissions/workflow-permissions.component';
import { WorkflowTransitionComponent } from '../views/site/workflow-transition/workflow-transition.component';
import { WorkflowComponent } from '../views/site/workflow/workflow.component';
import { WorkflowsComponent } from '../views/site/workflows/workflows.component';
import { SharedModule } from './shared.module';
import { SiteRoutingModule } from './site-routing.module';
import { EditorNameFormFieldComponent } from '../shared/components/form-fields/editor-name-form-field/editor-name-form-field.component';
import { LastEditedDateFormFieldComponent } from '../shared/components/form-fields/last-edited-date-form-field/last-edited-date-form-field.component';


// Begin imports related to the Telerik HTML editor compponent.
// Here is a help page that helped me resolve errors that I got when enablig the last line, for importing the Telerik EditorModule:
//     https://www.telerik.com/forums/no-exported-member-dialogsmodule
//
// Here are the commands I used to resolve the errors, the first two coming from the above article:
//     npm install -g npm-check-updates
//     ncu - u - f /^@progress/
//     npm install
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { EditorModule as TelerikHtmlEditorModule } from "@progress/kendo-angular-editor";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
// End imports related to the Telerik HTML editor compponent.

import { FieldConditionalLogicComponent } from '../shared/components/form-builder/properties/field-conditional-logic/field-conditional-logic.component';
import { ConfigureStructureFieldsDialog } from '../shared/dialogs/configure-structure-fields/configure-structure-fields.dialog';
import { NameFormFieldsDialog } from '../shared/dialogs/name-form-fields/name-form-fields.dialog';

import { SelectFormTemplateComponent } from '../shared/components/select-form-template/select-form-template.component';
import { NotificationCenterComponent } from '../shared/components/notification-center/notification-center.component';

@NgModule({
    imports: [
        CommonModule,
        ClipboardModule,
        RouterModule,
        SiteRoutingModule,
        SharedModule,
        TreeModule,
        ContextMenuModule,
        ToastModule,
        MatTooltipModule,
        // Reference for above comment:  https://stackoverflow.com/questions/47152530/tooltip-issue-mattooltip-not-working-in-angular
        MatPaginatorModule,
        MatProgressBarModule,
        MatSidenavModule,
        AngularSplitModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgbModule,
        MatStepperModule,
        MatChipsModule,
        MatTreeModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts')
        }),
        GridModule,
        KendoAngularContextMenuModule,
        // Begin imports related to the Telerik HTML editor compponent.
        InputsModule,
        ButtonsModule,
        LabelModule,
        TelerikHtmlEditorModule
        // End imports related to the Telerik HTML editor compponent.
    ],
    exports: [
        SharedModule,
        MatSidenavModule
    ],
    declarations: [
        HomePageComponent,
        HtmlEditorDialog,
        BreadcrumbsComponent,
        SiteMilestonesComponent,
        SiteMilestoneConfigComponent,
        SummaryComponent,
        ManageComponent,
        StructureComponent,
        FormsComponent,
        FormsHtmlOnlyComponent,
        DesignComponent,
        DesignFormHtmlComponent,
        DesignHomepageHtmlComponent,
        PermissionsPreviewComponent,
        WorkflowsComponent,
        WorkflowTransitionComponent,
        WorkflowComponent,
        FolderTreeComponent,
        RoleViewerComponent,
        SiteContactsComponent,
        SiteWorkflowStatusComponent,
        SiteRolesComponent,
        FolderDetailsComponent,
        FormDetailsComponent,
        WorkflowDetailsComponent,
        FormInstanceDetailsComponent,
        FormBuilderComponent,
        FlexibleSelectionFieldConfigurationComponent,
        FilterPipe,
        FilterFolderRoleMembersPipe,
        FilterRoleMembersPipe,
        // Form Fields
        FormFieldWrapperComponent,
        PreserveInlineStylesPipe,
        ShortTextFormFieldComponent,
        ParagraphFormFieldComponent,
        RichTextFormFieldComponent,
        IntegerFormFieldComponent,
        FlexFieldButtonsFormFieldComponent,
        DecimalFormFieldComponent,
        CurrencyFormFieldComponent,
        CheckboxFormFieldComponent,
        DateFormFieldComponent,
        DropDownFormFieldComponent,
        FlexibleSelectionFormFieldComponent,
        RadioButtonsFormFieldComponent,
        LabelFormFieldComponent,
        GridFormFieldComponent,
        FormulaFormFieldComponent,
        FormFieldPropertiesComponent,
        FormPropertiesComponent,
        LayoutRowPropertiesComponent,
        FormRendererComponent,
        FormFillerComponent,
        DynamicComponentHostDirective,
        CustomDateFormatDirective,
        DecimalFormatDirective,
        IntegerOnlyDirective,
        FluidHeightDirective,
        PrintableFormComponent,
        CascadingDropDownFormFieldComponent,
        AttachmentFormFieldComponent,
        FootnoteFormFieldComponent,
        FormConditionalPropertiesComponent,
        WorkflowPermissionsComponent,
        RawHtmlFormFieldComponent,
        InstructionsFormFieldComponent,
        InlineContentFormFieldComponent,
        DevOnlyFormFieldComponent,
        FileUploaderComponent,
        MultiCheckboxFormFieldComponent,
        MultiDropDownFormFieldComponent,
        SafePipe,
        PermissionsPreviewWfHierarchyComponent,
        PermissionsPreviewFiltersComponent,
        MaxPickerComponent,
        DocumentPublishingSettingsEditorDialog,
        AddContactDialog,
        DocumentPublishingPickerDialog,
        MagicStructureSetupDialog,
        ExportStructureInstancesDialog,
        ImportStructureInstancesDialog,
        ResponseManagementComponent,
        ResponseManagementConfigComponent,
        SelectFolderDialog,
        DisplayContentDialog,
        ImportFormDefinitionDialog,
        ImportFormInstancesDialog,
        ImportDragDropComponent,
        VirtualFolderPopoverComponent,
        ScheduledEventsDialog,
        SiteMilestoneDialog,
        CreateNotificationDialog,
        ExportDataDialog,
        MagicStructureMembershipComponent,
        ContactsFormFieldComponent,
        AssignNameDialog,
        GeocodeDialog,
        SiteBetaFeaturesComponent,
        FormFieldConstraintsComponent,
        FormInstanceHistoryComponent,
        ShowToHideFromComponent,
        ExportFormDataDialog,
        GridCascadingDropDownFormFieldComponent,
        CommentsFormFieldComponent,
        ExportCsvDialog,
        ContextMenuComponent,
        DecoratorButtonComponent,
        AutocompleteComponent,
        GridCellEditorDialog,
        GridFieldDesignerComponent,
        GridFieldEditorComponent,
        DesignHomepageComponent,
        KendoGridRemoteBindingDirective,
        FormInstanceHistoryRemoteDirective,
        ConfigureHomePageComponent,
        ConfigureBannerComponent,
        FormTemplateInstancesComponent,
        HtmlLinkFieldComponent,
        ValueConcatenatorFormFieldComponent,
        FormTemplateInstancesGridRemoteBindingDirective,
        ImportGridDataDialog,
        PermissionsComponent,
        PermissionRolesComponent,
        FolderPermissionsComponent,
        RoleMembershipDrawerComponent,
        MarkDataReadOnlyComponent,
        ConfigureHomePageGridColumnsDialog,
        ToggleSitePermissionModelComponent,
        HomePageActionDialog,
        EntityNameEditorComponent,
        TelerikHtmlEditorComponent,
        GenerateEtlJobComponent,
        UploadIconDialog,
        ListIconsDialog,
        GetSiteEtlMetadataDialog,
        FieldConditionalLogicComponent,
        ImportDataFromExcelDialog,
        ReorderGridColumnsDialog,
        ConfigureStructureFieldsDialog,
        NameFormFieldsDialog,
        SelectFormTemplateComponent,
        NotificationCenterComponent,
        NameFormFieldsDialog,
        EditorNameFormFieldComponent,
        LastEditedDateFormFieldComponent

    ],
    providers: [
        FolderResolver,
        FormResolver,
        SiteHomePageResolver,
        AsyncJobService,
        MaxPickerService,
        MessageService,
        TreeDragDropService,
        DocumentPublishingSettingsResolver,
        DocumentPublishingService,
        MagicStructureService, //VNEXT-1430: KLW - Due to changes from Angular 14 to 15, extra commas in the module definitions are no longer tolerated
        MostRecentFormSelectedService,
        ScheduledEventService,
        MilestoneService,
        MiscellaneousMetadataService,
        FormFieldService,
        FlexibleSelectionFieldService,
        FilterFolderRoleMembersPipe, 
        CachedFormFieldService,
        // Question:  why is CurrentSiteService not registered here or in another module file?
        FormFieldDataBusService,
        VnextReleaseFeaturesService,
        TypeAheadDropdownService,
        { provide: DateAdapter, useClass: CustomDatePickerAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        AutocompleteService,
        FieldConditionalLogicService,
        ValueConcatenatorService,
        SiteHomePageService,
        FolderPermissionService,
        PermissionTestingService,
        InlineContentService
    ]
})
export class SiteModule { }
